<template>
  <v-card max-width="700" class="mx-auto">
    <v-card-text v-html="text"></v-card-text>
  </v-card>
</template>

<script>
export default {
  data() {
    return {
      text: "",
    };
  },
  created() {
    this.refresh();
  },
  methods: {
    async refresh() {
      const res = await this.$axios.get("/api/about");
      this.text = res.data.text;
    },
  },
};
</script>
